export const environment = {
  title: 'Testbed: Potree Manager',
};
